
import { useAtom, useGet, useSet } from "state/jotai";
import { iso_free, iso_isrotating, turn_building } from "state/store.global";
import { useSendClick } from "./fetch/useSendClick";

export const useRotation = () => {
  const rotatemode = useGet(iso_free);
  const setRotatemode = useSet(iso_free);

  const isrotate = useGet(iso_isrotating);
  const setIsrotate = useSet(iso_isrotating);

  const [turnBuilding, setTurnBuilding] = useAtom(turn_building);

  const sendClick = useSendClick();


  const startRotation = () => {
    setRotatemode(true);
    setIsrotate(true);
    setTurnBuilding(true);
    sendClick("isometry_rotation");
  };

  const stopRotation = () => {
    setIsrotate(false);
    setTurnBuilding(true);
  };

  const handleRotate = () => {
    return rotatemode && isrotate ? stopRotation() : startRotation();
  };

  return {
    rotatemode,
    isrotate,
    turnBuilding,
    handleRotate,
  };
};